import HomePage from '~psp-pages/swiss/home/home.vue'
import RedemptionPage from '~psp-pages/swiss/redemption/redemption.vue'
import Payment from '~psp-pages/swiss/redemption/payment.vue'
import Summary from '~psp-pages/swiss/redemption/summary.vue'

import routerBuilder from './routerBuilder'

const router = routerBuilder({
  HomePage, RedemptionPage, Summary, Payment,
})

export default router
